<template>
<div>
  <div v-if="showLogs">
  <h1> Logs </h1>
  <b-card-group columns>
    <b-card>
    <b-button variant="primary" size="lg"
        @click="addLog(null)">New Log</b-button>
    </b-card>
    <b-card v-for="(log, i) in logs" :key="i">
      <div slot="header" style='text-align: right'>
        <b-button @click="editLog(log)">
          <font-awesome-icon icon="edit"
              class='link-button' ></font-awesome-icon>
        </b-button>
      </div>
      <b-card-text align='right'>
        {{toDate(log.date).toLocaleDateString("en-US", {
          weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
        })}}
        <br>
        <span v-if='log.objective != null && getObjective(log.objective.id).parent'>
          <span>
            {{quests_by_id[getObjective(log.objective.id).parent.id].title}} >
            </span>
          <span v-for='(qid, qi) in quest_to_parents[getObjective(log.objective.id).parent.id]'
            :key='qi'>
            {{quests_by_id[qid].title}} >
          </span>
        </span>
      </b-card-text>
      <b-card-text align='left' v-html="toMark(summarize(log))"></b-card-text>

    </b-card>
  </b-card-group>
  </div>
  <div v-if="showObjectives">
    <h1> Objectives </h1>
    <b-card-group columns style='flex-wrap:wrap'>
      <b-card v-for='oid in Object.keys(objectives_by_id)' :key="oid"
        :title="getObjective(oid).title"
        class="objective"
        :border-variant="getObjective(oid).complete?'success':'default'"
        style="min-width:100px;"
        @click="editObjective(getObjective(oid))">
        <b-card-text class='parents'>
        </b-card-text>
        <b-card-text>Number of logs: {{getObjective(oid).logs.length}}</b-card-text>
        <b-card-text v-html="toMark(getObjective(oid).description)"></b-card-text>
        <div slot="header" style='display: flex;flex-direction: row;justify-content: space-between;align-content : center;'>
          <div style="margin: auto 0;">
            <span v-for='(parent,i) in quest_to_parents[getObjective(oid).parent.id]' :key='i'
            :qid="'q'+parent">
            {{quests_by_id[parent].title}} >
            </span>
            <span
              :qid="'q'+getObjective(oid).parent.id">
              {{quests_by_id[getObjective(oid).parent.id].title}}</span>
          </div>
          <b-button variant="primary" @click.stop="addLog(oid)">Add log</b-button>
        </div>

        <b-card-group columns style="column-count:2 !important">
        <b-card v-for="(item, i) in getObjective(oid).items"
          :key="i"
          :header="item.title">
          <b-form-group v-if="item.type === 'checklist'" align="left">
            <b-form-checkbox v-for="(c, ci) in item.content"
              :key="ci"
              v-model="c.complete" tabindex="-1"
              disabled>
            {{c.title}}
            </b-form-checkbox>
          </b-form-group>
          <b-form-group v-if="item.type === 'counter'"
            :description="item.current + ' (between ' + item.min + ' and ' + item.max + ')'"
            >
            <b-input v-model.number="item.current"
              type="range"
              :max="item.max"
              :min="item.min" disabled/>
          </b-form-group>

        </b-card>
        </b-card-group>
      </b-card>
    </b-card-group>
  </div>

  <div v-if="showQuests">
    <h1>Quests</h1>
    <b-card-group columns>
      <b-card>
        <b-button variant="primary" size="lg"
            @click="addQuest(null)">add quest</b-button>
      </b-card>
      <b-card
        v-for='qid in quest_order' :key='qid'
        :title="quests_by_id[qid].title"
        :qid="'q'+qid"
        class='quest'
        @mouseover="highlightQuests(qid, true, false)"
        @mouseleave="highlightQuests(qid, false, false)"
        @click="editQuest(quests_by_id[qid])">
        <b-card-text class='parents' v-if='quests_by_id[qid].parent'>
          <span v-for='(parent,i) in quest_to_parents[qid]' :key='i'
            :qid="'q'+parent"
            @mouseover="highlightQuests(parent, true, true)"
            @mouseleave="highlightQuests(parent, false, true)">
            {{quests_by_id[parent].title}} >
          </span>
        </b-card-text>
        <b-card-text v-html="toMark(quests_by_id[qid].description)">
        </b-card-text>
        <div slot="footer">
          <b-button variant="primary"  size='sm'
            @click.stop="addObjective(qid)">
            add objective</b-button>
          <span style="display:inline-block; width: 4px;"></span>
          <b-button variant="primary" size='sm'
            @click.stop="addQuest(qid)">add quest</b-button>
          <span style="display:inline-block; width: 4px;" ></span>
        </div>
        <b-card-text v-if='quests_by_id[qid].objectives.length'>
          <b-card-group columns style='flex-wrap:wrap'>
            <b-card v-for='(obj, i) in quests_by_id[qid].objectives' :key="i"
              :title="getObjective(obj.id).title"
              :class=" {objective: true}"
              :bg-variant="getObjective(obj.id).complete?'success':'default'"
              :text-variant="getObjective(obj.id).complete?'white':''"
              style="min-width:100px;"
              @click.stop="editObjective(getObjective(obj.id))">
              <b-card-text v-html="toMark(getObjective(obj.id).description)"></b-card-text>
            </b-card>
          </b-card-group>
        </b-card-text>

      </b-card>
    </b-card-group>
  </div>

  <b-modal ref="log-modal"
    @hidden="resetLogModal"
    @ok="saveLog"
    :title="this.logData.ref? 'Edit log': 'New Log'" size="xl" scrollable>
    <div class="left">
      <b-form-group
        label="Objective:"
        label-for="parent"
        description=""
        label-cols-sm='2'
      >
        <b-form-select
          id="parent"
          v-model="logData.objective"
          :options="logParents"
        ></b-form-select>
      </b-form-group>
      <div v-if="objectiveRef != null">
        <b-button size='sm' @click='toggleObjectiveDetails'>toggle details</b-button>
        <br>
        <br>
        <div v-if='showObjectiveContent'>
          <b-card
            :title="objectiveRef.title">
            <b-card-text v-html="toMark(objectiveRef.description)">
            </b-card-text>

            <b-button
              @click="toggleLogObjectiveComplete"
              :variant="objComplete? 'success' : 'danger'">
              Mark as {{objComplete? 'incomplete' : 'complete'}}</b-button>
          </b-card>
          <br>
          <b-card-group columns>
          <b-card v-for="(item, i) in logData.objItems"
            :key="i"
            :header="item.title">
            <b-form-group v-if="item.type === 'checklist'">
              <b-form-checkbox v-for="(c, ci) in item.content"
                :key="ci"
                v-model="c.complete" tabindex="-1"
                @input="checkItemChanges">
                {{c.title}}
              </b-form-checkbox>
            </b-form-group>
            <b-form-group v-else-if="item.type === 'counter'"
              :description="item.current + ' (between ' + item.min + ' and ' + item.max + ')'">
              <b-input v-model.number="item.current"
                type="range"
                :max="item.max"
                :min="item.min"
                @input="checkItemChanges"/>
            </b-form-group>
          </b-card>
          </b-card-group>
        </div>
      </div>
      <b-form-group
        label="Date" label-for="logDate"
        label-cols-sm='1'>
        <b-form-input
          type="datetime-local"
          id="logDate"
          label-cols-sm='1'
          v-model="logData.date"/>
      </b-form-group>
      <b-form-group
        id="input-group-2"
        label="Description:"
        label-for="description"
        description=""
      >
        <b-form-textarea
          id="description"
          v-model="logData.description"
          placeholder="Log"
          rows="3"
          max-rows="100"
        ></b-form-textarea>
      </b-form-group>
    </div>
    <div class="right">
      <b-card>
      <b-card-text align='right'>
        {{new Date(logData.date).toLocaleDateString("en-US", {
          weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
        })}}
        <br>
        <span v-if='objectiveRef != null'>
          <span>{{quests_by_id[objectiveRef.parent.id].title}} > </span>
          <span v-for='(qid, qi) in quest_to_parents[objectiveRef.parent.id]'
            :key='qi'>
            {{quests_by_id[qid].title}} >
          </span>
          {{objectiveRef.title}}
        </span>

      </b-card-text>
      <b-card-text align='left' v-html="toMark(summarize(logData))"></b-card-text>

      </b-card>
    </div>

  </b-modal>

  <b-modal ref="edit-log-modal"
    @hidden="resetLogModal"
    @ok="saveLog"
    title="Edit log" size="xl" scrollable>
    <div class="left">
      <div v-if="objectiveRef != null">
        <b-button size='sm' @click='toggleObjectiveDetails'>toggle details</b-button>
        <br>
        <br>
        <div v-if='showObjectiveContent'>
        <b-card
          :title="objectiveRef.title">
          <b-card-text v-html="toMark(objectiveRef.description)">
          </b-card-text>

          <b-form-select v-model="logData.markComplete">
            <option :value="undefined"> Clear</option>
            <option :value="true">Mark as complete</option>
            <option :value="false">Mark as incomplete</option>
          </b-form-select>
          </b-card>
          <br>
          <b-card-group columns>
          <b-card v-for="(item, i) in logData.items"
            :key="i"
            :header="item.title">
            <b-form-group v-if="item.type === 'checklist'">
              <b-form-checkbox v-for="(c, ci) in item.content"
                :key="ci"
                v-model="c.complete" tabindex="-1">
                <b-input v-model="c.title" />
                <b-button v-if="showDelete"
                  size="sm" tabindex="-1"
                  @click="deleteChecklistItem(item, ci)">
                  Delete</b-button>
              </b-form-checkbox>
            </b-form-group>
              <b-button
              v-if="item.type === 'checklist'"
              size="sm"
              @click="addChecklistItem(item)">
              Add</b-button>

            <b-form-group v-else-if="item.type === 'counter'"
              :description="(item.before + item.delta) + ' (between ' + item.min + ' and ' + item.max + ')'">
              <b-input :value="item.before + item.delta"
                type="range"
                :max="item.max"
                :min="item.min"
              disabled/>
            </b-form-group>

            <div slot="footer">
              <b-form-group label="Title">
                <b-input v-model="item.title"/>
              </b-form-group>
              <b-form-group label="Delta" v-if="item.type=='counter'">
                <b-input v-model.number="item.delta " type="number"/>
              </b-form-group>
              <b-form-group label="Before" v-if="item.type=='counter'">
                <b-input v-model.number="item.before " type="number"/>
              </b-form-group>
              <b-form-group label="Min" v-if="item.type=='counter'">
                <b-input v-model.number="item.min" type="number"/>
              </b-form-group>
              <b-form-group label="Max" v-if="item.type=='counter'">
                <b-input v-model.number="item.max " type="number"/>
              </b-form-group>
              <b-button  v-if="showDelete"
                variant="danger" tabindex="-1"
                @click="deleteLogItem(i)">
                Delete</b-button>
            </div>
          </b-card>
        </b-card-group>
        </div>
      </div>
      <div v-else>
        <b-card>(No objective)</b-card>
      </div>
      <b-form-group
        label="Date" label-for="logDate"
        label-cols-sm='1'>
        <b-form-input
          type="datetime-local"
          id="logDate"
          label-cols-sm='1'
          v-model="logData.date"/>
      </b-form-group>
      <b-form-group
        id="input-group-2"
        label="Description:"
        label-for="description"
        description=""
      >
        <b-form-textarea
          id="description"
          v-model="logData.description"
          placeholder="Wat"
          rows="3"
          max-rows="100"
        ></b-form-textarea>
      </b-form-group>
    </div>
    <div class="right">
      <b-card>
      <b-card-text align='right'>
        {{new Date(logData.date).toLocaleDateString("en-US", {
          weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
        })}}
        <br>
        <span v-if='objectiveRef != null'>
          <span>{{quests_by_id[objectiveRef.parent.id].title}} > </span>
          <span v-for='(qid, qi) in quest_to_parents[objectiveRef.parent.id]'
            :key='qi'>
            {{quests_by_id[qid].title}} >
          </span>
          {{objectiveRef.title}}
        </span>

      </b-card-text>
      <b-card-text align='left' v-html="toMark(summarize(logData))"></b-card-text>

      </b-card>
    </div>
    <b-button  v-if="showDelete"
    variant="outline-secondary"  size='sm'
    @click="deleteLog">Delete Log</b-button>
  </b-modal>

  <b-modal ref="quest-modal"
    @hidden="resetQuestModal"
    @ok="saveQuest"
    :title="this.updateQuest.ref? 'Edit quest' : 'New quest'" size="lg" scrollable
    :hide-footer="placeholderText != null">
    <div v-if="placeholderText">{{placeholderText}}</div>
    <div v-else>
      <b-form-group
        id="input-group-2"
        label="Parent quest"
        label-cols-sm='2'
        label-for="qparent"
        description=""
      >
        <b-form-select
          id="qqparent"
          v-model="updateQuest.parent"
          :options="questParents"
        ></b-form-select>
      </b-form-group>
      <b-form-group
        id="input-group-1"
        label="Title"
        label-cols-sm='1'
        label-for="qtitle"
        description=""
      >
        <b-form-input
          id="qtitle"
          v-model="updateQuest.title"
          autofocus
          type="text"
          required
          placeholder="Enter title of this quest"
          @keyup.enter="submitQuest"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        id="input-group-2"
        label="Description:"
        label-for="qdescription"
        description=""
      >
        <div class="left">
          <b-form-textarea
            id="qdescription"
            v-model="updateQuest.description"
            placeholder="Quest summary"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </div>
        <div class="right">
          <div v-html="compiledQMarkdown"></div>
        </div>
      </b-form-group>

      <hr>
      <b-button
        variant="outline-secondary"  size='sm'
        @click="deleteQuest"
        v-if="showDelete && updateQuest.ref">Delete Quest</b-button>
    </div>
  </b-modal>
  <b-modal ref="objective-modal"
    @hidden="resetObjectiveModal"
    @ok="saveObjective"
    title="Objective" size="lg" scrollable
    @keyup.ctrl.86="submitObjective">

    <b-form-group
      id="input-group-2"
      label="Parent quest:"
      label-cols-sm='2'
      label-for="oparent"
      description=""
    >
      <b-form-select
        id="oparent"
        v-model="updateObjective.parent"
        :options="objectiveParents"
      ></b-form-select>
    </b-form-group>
    <b-form-group
      id="input-group-1"
      label="Title"
      label-for="otitle"
      label-cols-sm='1'
      description=""
    >
      <b-form-input
        id="otitle"
        v-model="updateObjective.title"
        type="text"
        autofocus
        required
        placeholder="Enter title of this objective"
        @keyup.enter="submitObjective"
      ></b-form-input>
    </b-form-group>
    <b-form-group
      id="input-group-2"
      label="Description:"
      label-for="odescription"
      description=""
    >
      <div class="left">
        <b-form-textarea
          id="odescription"
          v-model="updateObjective.description"
          placeholder="Objective details"
          rows="3"
          max-rows="10"
        ></b-form-textarea>
      </div>
      <div class="right">
        <div v-html="compiledOMarkdown"></div>
      </div>
    </b-form-group>
    <b-button
      @click="toggleObjectiveComplete"
      :variant="updateObjective.complete? 'danger' : 'success'">
      Mark as {{updateObjective.complete? 'incomplete' : 'complete'}}</b-button>
    <hr>
    <b-form-group description="">
      <b-card-group columns>
      <b-card v-for="(item, i) in updateObjective.items"
        :key="i"
        :header="item.title">
        <b-form-group v-if="item.type === 'counter'"
          :description="item.current + ' (between ' + item.min + ' and ' + item.max + ')'"
          >
          <b-input v-model.number="item.current"
            type="range"
            :max="item.max"
            :min="item.min"/>
        </b-form-group>
        <b-form-group v-if="item.type === 'checklist'">
          <b-form-checkbox v-for="(c, ci) in item.content"
            :key="ci"
            v-model="c.complete" tabindex="-1">
            <b-input v-model="c.title" />
            <b-button v-if="showDelete"
              size="sm" tabindex="-1"
              @click="deleteChecklistItem(item, ci, $event)">
              Delete</b-button>
          </b-form-checkbox>
        </b-form-group>

        <b-button
          v-if="item.type === 'checklist'"
          size="sm"
          @click="addChecklistItem(item)">
          Add</b-button>

        <div slot="footer">
          <b-form-group label="Title">
            <b-input v-model="item.title"/>
          </b-form-group>
          <b-form-group label="Min" v-if="item.type=='counter'">
            <b-input v-model.number="item.min" type="number"/>
          </b-form-group>
          <b-form-group label="Max" v-if="item.type=='counter'">
            <b-input v-model.number="item.max " type="number"/>
          </b-form-group>
          <b-button  v-if="showDelete"
            variant="danger" tabindex="-1"
            @click="deleteItem(i)">
            Delete</b-button>
        </div>
      </b-card>
      </b-card-group>
      <b-button variant="outline-primary" @click="addCheckList">Add Checklist</b-button>
      <b-button variant="outline-primary" @click="addCounter">Add Counter</b-button>
    </b-form-group>
    <hr>
    <b-button  v-if="showDelete && updateObjective.ref"
      variant="outline-secondary"  size='sm'
      @click="deleteObjective">Delete Objective</b-button>
  </b-modal>

</div>
</template>

<script>
import { mapState } from 'vuex'
const marked = require('marked')

// eslint-disable-next-line
Date.prototype.toDatetimeLocal = function toDatetimeLocal () {
  let date = this
  let ten = function (i) {
    return (i < 10 ? '0' : '') + i
  }
  let YYYY = date.getFullYear()
  let MM = ten(date.getMonth() + 1)
  let DD = ten(date.getDate())
  let HH = ten(date.getHours())
  let II = ten(date.getMinutes())
  let SS = ten(date.getSeconds())
  return YYYY + '-' + MM + '-' + DD + 'T' + HH + ':' + II + ':' + SS
}

export default {
  name: 'LogBox',
  data () {
    return {
      showObjectiveContent: true,
      deleteCounter: 0,
      logData: {
        description: '',
        objective: null,
        objItems: [],
        items: [],
        ref: null,
        markComplete: null,
        date: null,
        time: null
      },
      objComplete: null,
      addingLog: false,
      /* Objective/Quest stuff */
      placeholderText: null,
      updateQuest: {
        ref: null,
        title: '',
        description: '',
        parent: null,
        active: null
      },
      updateObjective: {
        ref: null,
        title: '',
        description: '',
        parent: null,
        items: [],
        complete: false
      }
    }
  },
  props: {
    showLogs: {
      type: Boolean,
      default: true
    },
    showObjectives: {
      type: Boolean,
      default: true
    },
    showQuests: {
      type: Boolean,
      default: true
    },
    showDelete: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    objectiveRef: function (val) {
      if (this.addingLog) {
        if (val) {
          this.objComplete = val.complete
          this.logData.objItems = JSON.parse(JSON.stringify(val.items))
        } else {
          this.logData.objItems = []
          this.objComplete = null
        }
        this.logData.items = []
      }
    },
    objComplete: function (val) {
      if (this.addingLog) {
        if (this.objectiveRef && this.objectiveRef.complete !== val) {
          this.logData.markComplete = val
        } else {
          this.logData.markComplete = null
        }
      }
    }
  },
  computed: {
    ...mapState(['logs', 'objectives_by_id', 'quests_by_id', 'quest_to_parents', 'quest_order']),
    logParents: function () {
      let p = [{ value: null, text: 'Misc' }]
      Object.keys(this.objectives_by_id).forEach(oid => {
        let obj = this.getObjective(oid)
        let parentQuest = this.quests_by_id[obj.parent.id]
        let objParents = ''
        this.quest_to_parents[obj.parent.id].forEach(pid => {
          objParents += this.quests_by_id[pid].title + ' > '
        })
        objParents += parentQuest.title
        let text = obj.title + ' (' + objParents + ')'
        p.push({ value: oid, text: text })
      })
      return p
    },
    objectiveRef: function () {
      if (this.logData.objective != null) {
        return this.getObjective(this.logData.objective)
      }
      return null
    },
    compiledLogMarkdown: function () {
      return marked(this.summarize(this.logData))
    },
    questParents: function () {
      let p = [{ value: null, text: 'None' }]
      Object.keys(this.quests_by_id).forEach(qid => {
        let q = this.quests_by_id[qid]
        if (q !== this.updateQuest.ref) {
          let text = ''
          if (this.quest_to_parents[qid]) {
            this.quest_to_parents[qid].forEach(qq => {
              text += this.quests_by_id[qq].title + ' > '
            })
          }
          text += q.title + ' >'
          p.push({ value: qid, text: text })
        }
      })
      return p
    },
    objectiveParents: function () {
      let p = []
      Object.keys(this.quests_by_id).forEach(qid => {
        let q = this.quests_by_id[qid]
        let text = ''
        if (this.quest_to_parents[qid]) {
          this.quest_to_parents[qid].forEach(qq => {
            text += this.quests_by_id[qq].title + ' > '
          })
        }
        text += q.title + ' >'
        p.push({ value: qid, text: text })
      })
      return p
    },
    compiledQMarkdown: function () {
      let text = ''
      /*
      if (this.updateObjective.parents) {
        this.updateObjective.parents.reverse().forEach(pid => {
          text += this.quests_by_id[pid].title + " > "
        })
        text += "\n\n"
      }

      let title = this.updateObjective.title;
      if (title) {
        title = "# " + title + "\n\n"
      }
      text += title */
      text += this.updateQuest.description
      return marked(text, { sanitize: true })
    },
    compiledOMarkdown: function () {
      let text = ''
      text += this.updateObjective.description
      return marked(text, { sanitize: true })
    }
  },
  methods: {
    toMark: function (text) {
      return marked(text, { sanitize: true })
    },
    getObjective: function(oid) {
      if (oid in this.objectives_by_id) {
        return this.objectives_by_id[oid]
      } else {
        return {
          active: false,
          complete: false,
          created: new Date().getTime(),
          desription: "",
          items: [],
          logs: [],
          modified: new Date().getTime(),
          parent: null,
          title: "Deleted objective :(",
          _ref: null
        }
      }
    },
    summarize: function (log) {
      let text = '__Objective: '
      if (log.objective) {
        let oid = typeof log.objective === 'string' ? log.objective : log.objective.id
        text += this.getObjective(oid).title
        text += '__'
        if (log.markComplete != null) {
          text += '\n\\\n_marked as ' + (log.markComplete ? 'complete' : 'incomplete') + '_'
        }
      } else {
        text += 'None__'
      }

      log.items.forEach(i => {
        text += '\n\n'
        if (i.type === 'checklist') {
          text += '_Worked on ' + i.title + '_\n'
          i.content.forEach(c => {
            let bullet = '* '
            if (c.complete) {
              bullet += 'Completed: '
            } else {
              bullet += 'Somehow uncompleted: '
            }
            bullet += c.title + '\n'
            text += bullet
          })
        } else if (i.type === 'counter') {
          text += '_Worked on ' + i.title
          text += ': + ' + i.delta + '_!\\\n Now at ' + (i.before + i.delta) + ' [min=' + i.min + ', max=' + i.max + ']\n\n'
        }
      })
      if (log.description.trim()) {
        text += '\n\n---------\n\n'
        text += log.description
      }

      return text
    },
    addLog: function (oid) {
      this.addingLog = true
      this.logData.objective = oid
      this.logData.date = new Date().toDatetimeLocal()
      this.$refs['log-modal'].show()
    },
    editLog: function (e) {
      console.log('editing log', e)
      this.logData.description = e.description
      if (e.objective) {
        this.logData.objective = e.objective.id
      }
      this.logData.items = JSON.parse(JSON.stringify(e.items))
      this.logData.ref = e
      this.logData.markComplete = e.markComplete
      this.logData.date = this.toDate(e.date).toDatetimeLocal()
      this.objComplete = e.complete
      this.$refs['edit-log-modal'].show()
      console.log(this.logData.date)
    },
    resetLogModal: function () {
      this.addingLog = false
      console.log('clearing log', this.logData)
      this.logData.description = ''
      this.logData.objective = null
      this.logData.items = []
      this.logData.objItems = []
      this.logData.ref = null
      this.objComplete = null
      this.logData.date = null
    },
    saveLog: function () {
      console.log('saving log', this.logData, this.markComplete)
      let method = 'updateLog'
      if (!this.logData.ref) {
        method = 'addLog'
      }

      let updateData = {
        description: this.logData.description,
        ref: this.logData.ref,
        objective: this.objectiveRef,
        items: this.logData.items,
        objItems: this.logData.objItems,
        markComplete: this.logData.markComplete,
        date: new Date(this.logData.date)
      }

      this.$store.dispatch(method, updateData)
    },
    checkItemChanges: function () {
      let origItems = this.objectiveRef.items
      let newItems = this.logData.objItems

      let items = []
      for (let i = 0; i < origItems.length; i++) {
        if (origItems[i].type === 'counter') {
          if (origItems[i].current !== newItems[i].current) {
            items.push({
              before: origItems[i].current,
              delta: newItems[i].current - origItems[i].current,
              max: origItems[i].max,
              min: origItems[i].min,
              title: origItems[i].title,
              type: origItems[i].type
            })
          }
        } else if (origItems[i].type === 'checklist') {
          let contentChange = []
          for (let j = 0; j < origItems[i].content.length; j++) {
            if (origItems[i].content[j].complete !== newItems[i].content[j].complete) {
              contentChange.push({
                complete: newItems[i].content[j].complete,
                title: origItems[i].content[j].title
              })
            }
          }
          if (contentChange.length > 0) {
            items.push({
              content: contentChange,
              title: origItems[i].title,
              type: origItems[i].type
            })
          }
        }
      }

      this.logData.items = items
    },
    toggleObjectiveDetails: function () {
      this.showObjectiveContent = !this.showObjectiveContent
    },
    deleteChecklistItem: function (item, ci) {
      item.content.splice(ci, 1)
    },
    addChecklistItem: function (item) {
      item.content.push({
        complete: true,
        title: ''
      })
    },
    toggleLogObjectiveComplete: function () {
      this.objComplete = !this.objComplete
    },
    deleteLogItem: function (i) {
      this.logData.items.splice(i, 1)
    },
    deleteLog: function () {
      if (this.deleteCounter > 5) {
        this.$store.dispatch('deleteLog', {
          ref: this.logData.ref
        }).then(() => {
          this.$refs['edit-log-modal'].hide()
        })
      } else {
        if (this.deletecounter === 0) {
          alert('delete disabled!')
        } else if (this.deletecounter === 10) {
          alert('delete now enabled')
        }
        this.deleteCounter += 1
      }
    },
    toDate: function (date) {
      if (typeof date.getMonth === 'function') {
        return date
      } else {
        return date.toDate()
      }
    },
    // QUEST METHODS
    /* Quest Form */
    editQuest: function (e) {
      console.log('editing quest', e)
      this.placeholderText = null
      this.updateQuest.ref = e
      this.updateQuest.title = e.title
      this.updateQuest.description = e.description
      if (e.parent) {
        this.updateQuest.parent = e.parent.id
      }
      this.$refs['quest-modal'].show()
    },
    addQuest: function (qid) {
      this.placeholderText = null
      if (qid) {
        this.updateQuest.parent = qid
      }
      this.$refs['quest-modal'].show()
    },
    resetQuestModal: function () {
      console.log('clearing quest')
      this.updateQuest.ref = null
      this.updateQuest.title = ''
      this.updateQuest.description = ''
      this.updateQuest.parent = null
      this.placeholderText = null
    },
    saveQuest: function (e) {
      let method = 'updateQuest'
      if (!this.updateQuest.ref) {
        method = 'addQuest'
      }
      this.$store.dispatch(method, {
        title: this.updateQuest.title,
        description: this.updateQuest.description,
        ref: this.updateQuest.ref,
        parent: this.updateQuest.parent
      })
      if (method === 'addQuest') {
        this.placeholderText = 'Quest successfully added!'
        e.preventDefault()
      }
    },
    /* Objective Form */
    editObjective: function (e) {
      console.log('editing objective', e)
      this.updateObjective.ref = e
      this.updateObjective.title = e.title
      this.updateObjective.description = e.description
      this.updateObjective.parent = e.parent.id
      this.updateObjective.complete = e.complete
      this.updateObjective.items = JSON.parse(JSON.stringify(e.items))
      this.$refs['objective-modal'].show()
    },
    addObjective: function (e) {
      console.log('adding objective', e)
      this.updateObjective.parent = e
      this.$refs['objective-modal'].show()
    },
    resetObjectiveModal: function () {
      console.log('clearing objective')
      this.updateObjective.ref = null
      this.updateObjective.title = ''
      this.updateObjective.description = ''
      this.updateObjective.parent = null
      this.updateObjective.complete = false
      this.updateObjective.items = []
    },
    saveObjective: function () {
      console.log('saving objective', this.updateObjective)
      let method = 'updateObjective'
      if (!this.updateObjective.ref) {
        method = 'addObjective'
      }
      this.$store.dispatch(method, {
        title: this.updateObjective.title,
        description: this.updateObjective.description,
        ref: this.updateObjective.ref,
        parent: this.updateObjective.parent,
        items: this.updateObjective.items,
        complete: this.updateObjective.complete
      })
    },
    addCheckList: function () {
      this.updateObjective.items.push({
        content: [],
        title: 'New checklist',
        type: 'checklist'
      })
    },
    addCounter: function () {
      this.updateObjective.items.push({
        current: 0,
        title: 'New counter',
        min: 0,
        max: 10,
        type: 'counter'
      })
    },
    toggleObjectiveComplete: function () {
      this.updateObjective.complete = !this.updateObjective.complete
    },
    submitQuest: function (e) {
      this.saveQuest(e)
      this.$refs['quest-modal'].hide()
    },
    submitObjective: function (e) {
      this.saveObjective(e)
      this.$refs['objective-modal'].hide()
    },
    submitLog: function (e) {
      let modal = 'log-modal'
      if (this.logData.ref) {
        modal = 'edit-log-modal'
      }
      this.saveLog(e)
      this.$refs[modal].hide()
    },
    maybeSubmit: function (e) {
      if (e.ctrlKey && e.keycode === 83) {
        e.preventDefault()
        if (this.updateQuest.title) {
          this.submitQuest(e)
        } else if (this.updateObjective.title) {
          this.submitObjective(e)
        } else if (this.logData.description.length) {
          this.submitLog(e)
        }
      }
    },
    deleteObjective: function () {
      if (this.deleteCounter > 10) {
        this.$store.dispatch('deleteObjective', {
          ref: this.updateObjective.ref
        }).then(() => {
          this.$refs['objective-modal'].hide()
        })
      } else {
        if (this.deletecounter === 0) {
          alert('delete disabled!')
        } else if (this.deletecounter === 10) {
          alert('delete now enabled')
        }
        this.deleteCounter += 1
      }
    },
    deleteQuest: function () {
      if (this.updateQuest.ref.children.length > 0 ||
          this.updateQuest.ref.objectives.length > 0) {
        let text = 'Please clear out all children!\n'
        text += 'quests: ' + this.updateQuest.ref.children.length + '\n'
        text += 'objectives: ' + this.updateQuest.ref.objectives.length + '\n'
        alert(text)
      } else {
        this.$store.dispatch('deleteQuest', {
          ref: this.updateQuest.ref
        }).then(response => {
          this.placeholderText = 'Quest deleted!'
        })
      }
    },
    deleteItem: function (i) {
      this.updateObjective.items.splice(i, 1)
    },
    highlightQuests: function (e, highlight, highlightParent) {
      let selector = '[qid=q' + e + ']'
      if (!highlightParent) {
        selector = 'span' + selector
      }
      this.$el.querySelectorAll(selector).forEach(el => {
        if (highlight) { el.classList.add('highlight') } else { el.classList.remove('highlight') }
      })
    }
  },
  beforeMount () {
    window.addEventListener('keydown', this.maybeSubmit)
  },
  mounted () {

  }
}
</script>

<style lang="scss" scoped>
h1 {
  margin: 1em;
}
#content {
  display: block;
  justify-content: flex-start;
  align-items: stretch;
  flex-wrap: wrap;
  margin: 0px auto;
  padding: 20px;
  max-width: 1200px;
  background: white;
}

.left,.right{
  width: 49%;
  display: inline-block;
  vertical-align: top;
}

.right {
  padding: 3px;
  padding-left: 7px;
}

.parents {
  font-size: 14px;
  color: #aaa;
}
.highlight{
  background: pink;
  cursor: pointer;
}
.quest:hover {
  border-color: #0069d9;
}

.objective:hover {
  background: #f3f3f3;
}
</style>
